import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { CallcardToolsModalComponent } from '../../components/callcard-tools-modal/callcard-tools-modal.component';
import { CardTool, CardToolsGroup } from '../../schema/card-tools-group';

@Injectable({
  providedIn: 'root'
})
export class CardToolsProviderService {
  private _cardToolGroups: CardToolsGroup[] = [];
  get cardToolGroups(): CardToolsGroup[] {
    return this._cardToolGroups;
  }

  get isEmpty(): boolean {
    return this._cardToolGroups.length == 0;
  }

  private _change: Subject<any> = new Subject();
  get $change(): Observable<any> {
    return this._change.asObservable();
  }

  constructor(private modalController: ModalController) {}

  addCardToolsGroup(cardToolsGroup: CardToolsGroup) {
    if (this.cardToolGroups.indexOf(cardToolsGroup) == -1) {
      cardToolsGroup.tools.sort((a, b) => a.priority - b.priority);

      this.cardToolGroups.push(cardToolsGroup);
      this.cardToolGroups.sort((a, b) => a.priority - b.priority);

      this._change.next(null);
    }
  }

  removeCardToolsGroup(cardToolsGroup: CardToolsGroup) {
    const idx = this.cardToolGroups.indexOf(cardToolsGroup);
    if (idx !== -1) {
      this.cardToolGroups.splice(idx, 1);
      this._change.next(null);
    }
  }

  showTools(cardId: string) {
    this.modalController
      .create({
        component: CallcardToolsModalComponent,
        componentProps: {
          cardToolGroups: [...this.cardToolGroups]
        }
      })
      .then(modal => modal.present().then(() => modal.onDidDismiss().then(result => (result.data as CardTool)?.execute(cardId))));
  }
}
